export function getDeleteHandlers({ newContacts, onClick, onRemoveContact }) {
  return newContacts.reduce((acc, contact) => {
    acc[contact.id] =
      newContacts.length === 1
        ? onClick
        : function handleDeleteContact() {
            onRemoveContact(contact.id)
          }

    return acc
  }, {})
}

export function getIsLastContact({ index, newContacts }) {
  return index === newContacts.length - 1
}

export function getIsAnyFieldEmpty({ name, newContacts, values }) {
  return newContacts.some(contact => {
    const contactValues = values[contact.id]

    return !contactValues || !contactValues[name]
  })
}
